import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { InnerPageLayoutComponent } from 'src/app/components/layouts/inner-page-layout/inner-page-layout.component';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ReportsService } from 'src/app/services/reports.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-consolidated-dashboard',
  templateUrl: './consolidated-dashboard.component.html',
  styleUrls: ['./consolidated-dashboard.component.scss']
})
export class ConsolidatedDashboardComponent implements OnInit {

  @ViewChild('divClick') divClick: ElementRef;
  @ViewChild('miDrillDownData') miDrillDownData: ElementRef;
  @ViewChild('pondDrillDownData') pondDrillDownData: ElementRef;
  @ViewChild('miDistrictWiseDataCard') miDistrictWiseDataCard: ElementRef;
  @ViewChild('pondDistrictWiseDataCard') pondDistrictWiseDataCard: ElementRef;

  public pieChartData: any = [];
  public miDoughnutYearWiseData: any = [];
  public pondDoughnutYearWiseData: any = [];
  public options: any;
  public options1: any;
  public options2: any;
  public optionsLine: any;
  public optionsMIDW: any;
  public optionsPondDW: any;
  public optionsMIScheme: any;
  public optionsSubsidy: any;
  public optionsCaste: any;
  public optionsAppType: any;
  public optionsComponent: any;


  public miData: any;
  public miYearWiseData: any;
  public miBifurcatedData: any;

  public pondData: any;
  public pondYearWiseData: any;
  public pondBifurcatedData: any;

  public miDistrictWiseData: any;
  public miDistrictWiseDataForChart: any;
  public miDistrictWiseDashboardData: any;
  public miDistrictWiseDashboarSchemedData: any = [];
  public miDistrictWiseSchemeDataForGraph: any;

  public pondDistrictWiseData: any;
  public pondDistrictWiseDataForChart: any;
  public pondDistrictWiseDashboardData: any;
  public pondDistrictWiseDashboarSchemedData: any = [];
  public pondDistrictWiseSchemeDataForGraph: any;

  // public subsidyData: any;
  public subsidyDataForChart: any;

  public subsidyAreaDataForChart: any;
  public subsidyAmountDataForChart: any;
  public Paymentstage: any;

  // public casteData: any;
  public casteDataForChart: any;

  // public appTypeData: any;
  public appTypeDataForChart: any;

  // public componentData: any;
  public componentDataForChart: any;

  // public yearWiseData: any;
  public yearWiseDataForChart: any;

  public showMIUnderProcessDetails: boolean = false;
  public showMICompletedDetails: boolean = false;
  public showMIRejectedDetails: boolean = false;
  public showMIIncompletedDetails: boolean = false;
  public showMITotalDDDetails: boolean = false;
  public showMITotalDetails: boolean = false;

  public showPondCompletedDetails: boolean = false;
  public showPondUnderProcessDetails: boolean = false;
  public showPondRejectedDetails: boolean = false;
  public showPondIncompleteDetails: boolean = false;
  public showPondTotalDetails: boolean = false;

  public pieChartOptions: any = {}

  public districtWiseHeader = `All districts details`;

  public userId: any;

  public totalSubsidyDisbursed: number = 0;
  public totalAppCompleted: number = 0;
  public totalMIAreaCompleted: number = 0;

  public totalSubsidyDisbursedPond1STage: number = 0;
  public totalAppCompletedPond1STage: number = 0;
  public totalAreaCompletedPond1STage: number = 0;

  public totalSubsidyDisbursedPond2STage: number = 0;
  public totalAppCompletedPond2STage: number = 0;
  public totalAreaCompletedPond2STage: number = 0;

  public totalSubsidyDisbursedPond3STage: number = 0;
  public totalAppCompletedPond3STage: number = 0;
  public totalAreaCompletedPond3STage: number = 0;

  // private targetTotalSubsidyDisbursed = 0;
  // private targetTotalAppCompleted = 0;
  // private targetTotalMIAreaCompleted = 0;
  userType: any = ''
  public showMIDistrciData: boolean = false;
  public showPONDDistrciData: boolean = false;
  vendorCode: any = ''

  jeLogin: any;
  jeorxenLogin: any;
  xenLogin: any;
  ddAssociate: any;
  dmicada: any;
  dd_ew: any;
  admin: any;
  cao: any;

  yearHeaderColor: any = 'blacck';
  yearHeadertext: any = '2022-23 Onwards';

  public selectedYearForData: any = '';
  public filterTypeName: any = '';

  // public showDashboard: boolean = true;
  public showOnlyMI: boolean = false;
  public showOnlyPond: boolean = false;

  constructor(
    public appMain: InnerPageLayoutComponent,
    private reportsService: ReportsService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) {
    Chart.register(ChartDataLabels);

    const tokenData = sessionStorage.getItem('token') ? 
      JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'))) : {};

    if (tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')) {
      this.jeLogin = true;
      this.jeorxenLogin = true;
    }
    if (tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')) {
      this.xenLogin = true;
      this.jeorxenLogin = true;
    }
    else if (tokenData && (tokenData.role == 'DD Associate')) {
      this.ddAssociate = true;
    }
    else if (tokenData && (tokenData.role == 'DMICADA')) {
      this.dmicada = true;
    }
    else if (tokenData && (tokenData.role == 'DD-EW')) {
      this.dd_ew = true;
    }
    else if (tokenData && ((tokenData.role == 'ADMIN') || (tokenData.role == 'WebAdmin'))) {
      this.admin = true;
    }
    else if (tokenData && (tokenData.role == 'CAO')) {
      this.cao = true;
    }
  }

  ngOnInit(): void {
    this.selectedYearForData = '';

    setTimeout(() => {
      this.divClick.nativeElement.click();
    }, 200);

    this.animateCounter('totalSubsidyDisbursed', this.totalSubsidyDisbursed);
    this.animateCounter('totalAppCompleted', this.totalAppCompleted);
    this.animateCounter('totalMIAreaCompleted', this.totalMIAreaCompleted);

    this.animateCounter('totalSubsidyDisbursedPond1STage', this.totalSubsidyDisbursedPond1STage);
    this.animateCounter('totalAppCompletedPond1STage', this.totalAppCompletedPond1STage);
    this.animateCounter('totalAreaCompletedPond1STage', this.totalAreaCompletedPond1STage);

    this.animateCounter('totalSubsidyDisbursedPond2STage', this.totalSubsidyDisbursedPond2STage);
    this.animateCounter('totalAppCompletedPond2STage', this.totalAppCompletedPond2STage);
    this.animateCounter('totalAreaCompletedPond2STage', this.totalAreaCompletedPond2STage);

    this.animateCounter('totalSubsidyDisbursedPond3STage', this.totalSubsidyDisbursedPond3STage);
    this.animateCounter('totalAppCompletedPond3STage', this.totalAppCompletedPond3STage);
    this.animateCounter('totalAreaCompletedPond3STage', this.totalAreaCompletedPond3STage);

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = (JSON.parse(payload)?.sub).toLowerCase();
    // this.userIdUpperCase = JSON.parse(payload)?.sub


    if (this.dmicada) {
      this.loadMIYearWiseData();

      this.onPieChartClick({ element: { index: 0 } });
    } else if (this.dd_ew) {
      // this.loadPondData();
      this.loadPondYearWiseData();
      this.onPieChartClick({ element: { index: 1 } });
    } else {
      this.loadMIYearWiseData();
      this.loadPondYearWiseData();

      this.onPieChartClick({ element: { index: 100 } });
      // this.loadMIData();
      // this.loadPondData();
    }
  }

  private animateCounter(property: string, endValue: number): void {
    const duration = 2000; // Duration of the animation in milliseconds
    const frameRate = 60; // Number of updates per second
    const totalFrames = (duration / 1000) * frameRate;
    let frame = 0;

    const intervalId = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const currentCount = Math.floor(progress * endValue);

      this[property] = currentCount;

      if (frame >= totalFrames) {
        clearInterval(intervalId);
        this[property] = endValue; // Ensure the final value is set
      }
    }, 1000 / frameRate);
  }

  onClearFinYear(val) {
    this.filterTypeName = '';
    this.selectedYearForData = '';
    this.yearHeadertext = '2022-23 Onwards';
    this.yearHeaderColor = 'black';

    if (val == 'MI') {
      this.onPieChartClick({ element: { index: 0 } });
    } else if (val == 'Pond') {
      this.onPieChartClick({ element: { index: 1 } });
    }

    // if (this.dmicada) {
    //   this.onPieMIYearWiseChartClick({ element: { index: 100 } });
    // } else if (this.dd_ew) {
    //   this.onPiePondYearWiseChartClick({ element: { index: 100 } });
    // } else {
    //   this.onPieMIYearWiseChartClick({ element: { index: 100 } });
    //   this.onPiePondYearWiseChartClick({ element: { index: 100 } });
    // }
  }

  loadPondYearWiseData() {
    this.loader.start();
    let sub = this.reportsService
      .pondYearWiseTotalAppCount()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.pondYearWiseData = data;
            this.loadPondDoughnutYearWiseData();

          } else {
            this.pondYearWiseData = [];
            this.loadPondDoughnutYearWiseData();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.pondYearWiseData = [];
          this.loadPondDoughnutYearWiseData();


          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIYearWiseData() {
    this.loader.start();
    let sub = this.reportsService
      .miYearWiseTotalAppCount()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miYearWiseData = data;
            this.loadMIDoughnutYearWiseData();

          } else {
            this.miYearWiseData = [];
            this.loadMIDoughnutYearWiseData();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miYearWiseData = [];
          this.loadMIDoughnutYearWiseData();


          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIData() {
    this.loader.start();
    let sub = this.reportsService
      .getMIAggregateTabsDataNew(this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miData = data[0];
            this.loadPieChartData();
            this.loadMIBifurcatedData();

          } else {
            this.miData = [];
            this.loadPieChartData();
            this.loadMIBifurcatedData();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miData = [];

          this.loadPieChartData();
          this.loadMIBifurcatedData();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadPondData() {
    this.loader.start();
    let sub = this.reportsService
      .getPondAggregateTabsDataNew(this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.pondData = data[0];
            this.loadPieChartData();
            this.loadPondBifurcatedData();

            // //save data in session storage
            // if (finYear == '') {
            //   window.sessionStorage.setItem('MIDataAll', JSON.stringify(data));
            // }
            // else if (finYear == '2022-23') {
            //   window.sessionStorage.setItem('MIData2223', JSON.stringify(data));
            // }
            // else if (finYear == '2023-24') {
            //   window.sessionStorage.setItem('MIData2324', JSON.stringify(data));
            // }

          } else {
            this.pondData = [];
            this.loadPieChartData();
            this.loadPondBifurcatedData();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.pondData = [];

          this.loadPieChartData();
          this.loadPondBifurcatedData();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadPieChartData1() {

    let miTotalCount = this.miData ? (this.miData?.totalApp ? this.miData?.totalApp : 0) : 0;
    let pondTotalCount = this.pondData ? (this.pondData?.totalApp ? this.pondData?.totalApp : 0) : 0;


    this.pieChartOptions = {
      animationEnabled: true,
      theme: "dark2",
      colorSet: "customColorSet",
      title: {
        text: "Micor Irrigation Total Applications"
      },
      data: [{
        type: "doughnut",
        indexLabel: "{name}: {y}",
        innerRadius: "90%",
        yValueFormatString: "#,##0.00",
        dataPoints: [
          { y: miTotalCount, name: `MI(PDMC)` },
          { y: pondTotalCount, name: `Pond/Tank` },
        ]
      }]
    }
  }

  loadPieChartData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    let miTotalCount = this.miData ? (this.miData?.totalApp ? this.miData?.totalApp : 0) : 0;
    let pondTotalCount = this.pondData ? (this.pondData?.totalApp ? this.pondData?.totalApp : 0) : 0;


    if (this.dmicada) {
      this.pieChartData = {
        labels: [`MI(PDMC): (${miTotalCount}) `],
        datasets: [
          {
            data: [miTotalCount, pondTotalCount],
            backgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 102, 204)',
              '#2E7D32'
            ],
            hoverBackgroundColor: [
              '#2E7D32',
              // 'rgb(0, 102, 204)',
            ],
            borderWidth: 2
          },
        ],
      };
    } else if (this.dd_ew) {
      this.pieChartData = {
        labels: [`Pond/Tank: (${pondTotalCount})`],
        datasets: [
          {
            data: [pondTotalCount],
            backgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 102, 204)',
              '#0D47A1'
            ],
            hoverBackgroundColor: [
              '#0D47A1',
              // 'rgb(0, 102, 204)',
            ],
            borderWidth: 2
          },
        ],
      };
    } else {
      this.pieChartData = {
        labels: [`MI(PDMC): (${miTotalCount}) `, `Pond/Tank: (${pondTotalCount})`],
        datasets: [
          {
            data: [miTotalCount, pondTotalCount],
            backgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 102, 204)',
              '#2E7D32',
              '#0D47A1'
            ],
            hoverBackgroundColor: [
              '#2E7D32',
              '#0D47A1'
            ],
            borderWidth: 2
          },
        ],
      };
    }


    this.options = {
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: '#FFFFFF',
          offset: -7,
          font: {
            weight: 'bold',
            size: 8
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
    };
  }

  loadMIDoughnutYearWiseData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    const totalAppsArray = this.miYearWiseData.map(item => item.TotalApps);
    const finyearArray = this.miYearWiseData.map(item => `${item.finyear}(${item.TotalApps})`);

    // let miTotalCount = this.miYearWiseData ? (this.miYearWiseData?.totalApp ? this.miYearWiseData?.totalApp : 0) : 0;
    // let pondTotalCount = this.pondData ? (this.pondData?.totalApp ? this.pondData?.totalApp : 0) : 0;


    if (this.dmicada || this.admin || this.cao) {
      this.miDoughnutYearWiseData = {
        labels: finyearArray,
        datasets: [
          {
            data: totalAppsArray,
            backgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 153, 115)',
              // 'rgb(153, 0, 0)',
              '#77DD77',
              '#55b555',
              '#418e41',
              '#276727',
            ],
            hoverBackgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 153, 115)',
              // 'rgb(153, 0, 0)',
              '#77DD77',
              '#55b555',
              '#418e41',
              '#276727',
            ],
            borderWidth: 2
          },
        ],
      };
    }


    this.options = {
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: '#FFFFFF',
          offset: -7,
          font: {
            weight: 'bold',
            size: 8
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
    };
  }

  loadPondDoughnutYearWiseData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    const totalAppsArray = this.pondYearWiseData.map(item => item.TotalApps);
    const finyearArray = this.pondYearWiseData.map(item => `${item.finyear}(${item.TotalApps})`);

    // let miTotalCount = this.miYearWiseData ? (this.miYearWiseData?.totalApp ? this.miYearWiseData?.totalApp : 0) : 0;
    // let pondTotalCount = this.pondData ? (this.pondData?.totalApp ? this.pondData?.totalApp : 0) : 0;


    if (this.dd_ew || this.admin || this.cao) {
      this.pondDoughnutYearWiseData = {
        labels: finyearArray,
        datasets: [
          {
            data: totalAppsArray,
            backgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 153, 115)',
              // 'rgb(153, 0, 0)',
              // '#BCD2E8',
              '#91BAD6',
              '#73A5C6',
              '#528AAE',
              '#2E5984',
            ],
            hoverBackgroundColor: [
              // 'rgb(51, 153, 102)',
              // 'rgb(0, 153, 115)',
              // 'rgb(153, 0, 0)',
              '#91BAD6',
              '#73A5C6',
              '#528AAE',
              '#2E5984',
            ],
            borderWidth: 2
          },
        ],
      };
    }


    this.options = {
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: '#FFFFFF',
          offset: -7,
          font: {
            weight: 'bold',
            size: 8
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
    };
  }

  loadMIBifurcatedData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.miBifurcatedData = {
      // labels: [`MI(PDMC) Applications: (${miTotalCount}) `, `Pond/Tank Applications: (${pondTotalCount})`],
      labels: ['Completed', 'Under Process', 'Rejected', 'Incomplete'],
      datasets: [
        {
          data: [this.miData?.CompletedApps, this.miData?.UnProcessedApps, this.miData?.rejectedApp, this.miData?.InCompleteApps],
          backgroundColor: [
            '#2eb82e',
            '#e6e600',
            '#ff0000',
            '#ff9900',
          ],
          hoverBackgroundColor: [
            '#5cd65c',
            '#ffff00',
            '#ff6666',
            '#ffc266',
          ],
          label: ''
        },
      ],
    };

    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        // y: {
        //   type: 'logarithmic', // Use logarithmic scale
        //   ticks: {
        //     min: 0,
        //     font: {
        //       weight: 'bold',
        //       color: 'black'
        //     },
        //   },
        //   grid: {
        //     display: false,
        //     // color: this.surfaceBorder,
        //     // drawBorder: false,
        //   },
        // },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : (value / 1000) + 'K';
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
      },
      }
    };
  }

  loadPondBifurcatedData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.pondBifurcatedData = {
      // labels: [`MI(PDMC) Applications: (${miTotalCount}) `, `Pond/Tank Applications: (${pondTotalCount})`],
      labels: ['Completed', 'Under Process', 'Rejected', 'Incomplete'],
      datasets: [
        {
          data: [this.pondData?.CompletedApps, this.pondData?.UnProcessedApps, this.pondData?.rejectedApp, this.pondData?.InCompleteApps],
          backgroundColor: [

            '#2eb82e',
            '#e6e600',
            '#ff0000',
            '#ff9900',

          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--yellow-500'),
            '#5cd65c',
            '#ffff00',
            '#ff6666',
            '#ffc266',
            // documentStyle.getPropertyValue('--pink-400'),
          ],
          label: ''
        },
      ],
    };


    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        // y: {
        //   type: 'logarithmic', // Use logarithmic scale
        //   ticks: {
        //     min: 0,
        //     font: {
        //       weight: 'bold',
        //       color: 'black'
        //     },
        //   },

        //   grid: {
        //     display: false,
        //     // color: this.surfaceBorder,
        //     // drawBorder: false,
        //   },
        // },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : (value / 1000) + 'K';
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
      }
    };
  }

  onMIChartClick(event) {
    if (event?.element?.index == 0) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMICompletedDetails = true;
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = false;
      this.showPondIncompleteDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
    }
    else if (event?.element?.index == 1) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMIUnderProcessDetails = true;
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = false;
      this.showPondIncompleteDetails = false;
      this.showMICompletedDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
    } else if (event?.element?.index == 2) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = false;
      this.showMICompletedDetails = false;
      this.showPondIncompleteDetails = false;
      this.showMIRejectedDetails = true;
      this.showMIIncompletedDetails = false;
    }
    else if (event?.element?.index == 3) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = false;
      this.showMICompletedDetails = false;
      this.showPondIncompleteDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = true;
    }
    else {
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;

      this.showMICompletedDetails = false;
      this.showPondCompletedDetails = false;

      this.showMIRejectedDetails = false;
      this.showPondRejectedDetails = false;

      this.showPondIncompleteDetails = false;
      this.showMIIncompletedDetails = false;
    }
  }

  onPondChartClick(event) {
    if (event?.element?.index == 0) {
      setTimeout(() => this.pondDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = true;
      this.showPondRejectedDetails = false;
      this.showMICompletedDetails = false;
      this.showMIUnderProcessDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
      this.showPondIncompleteDetails = false;
    } else if (event?.element?.index == 1) {
      setTimeout(() => this.pondDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showPondUnderProcessDetails = true;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = false;
      this.showMICompletedDetails = false;
      this.showMIUnderProcessDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
      this.showPondIncompleteDetails = false;
    } else if (event?.element?.index == 2) {
      setTimeout(() => this.pondDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = true;
      this.showMICompletedDetails = false;
      this.showMIUnderProcessDetails = false;
      this.showPondIncompleteDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
    } else if (event?.element?.index == 3) {
      setTimeout(() => this.pondDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showPondRejectedDetails = false;
      this.showMICompletedDetails = false;
      this.showMIUnderProcessDetails = false;
      this.showPondIncompleteDetails = true;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
    }
    else {
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showPondCompletedDetails = false;
      this.showMICompletedDetails = false;
      this.showMIRejectedDetails = false;
      this.showPondIncompleteDetails = false;
      this.showMIIncompletedDetails = false;
      this.showPondRejectedDetails = false;
    }
  }

  onPieChartClick(event) {
    if (event?.element?.index == 0) {
      this.loadMIData();
      this.showOnlyMI = true;
      this.showOnlyPond = false;
      this.showPONDDistrciData = false;
      this.pondDistrictWiseDashboardData = false;
      this.pondDistrictWiseDashboarSchemedData = [];
      this.loadMIDistrictWiseData('');
      this.loadMIDistrictWiseDashboardData('');
      this.loadMIDistrictWiseDashboardSchemeData('');
      this.showMIDistrciData = true;
      this.districtWiseHeader = `All districts details`
    } else if (event?.element?.index == 1) {
      this.loadPondData();
      this.showOnlyMI = false;
      this.showOnlyPond = true;
      this.showMIDistrciData = false;
      this.miDistrictWiseDashboardData = false;
      this.miDistrictWiseDashboarSchemedData = [];
      this.loadPONDDistrictWiseData('');
      this.loadPONDDistrictWiseDashboardData('');
      this.loadPondDistrictWiseDashboardSchemeData('');
      this.showPONDDistrciData = true;
      this.districtWiseHeader = `All districts details`
    } else if (event?.element?.index == 100) {  //in case of admin and cao login
      this.loadMIData();
      this.loadPondData();
    } else {
      // this.showMITotalDetails = false;
    }
  }

  onPieMIYearWiseChartClick(event) {
    this.filterTypeName = 'MI';

    this.yearHeadertext = event?.element?.index == 0 ? '2022-23' : event?.element?.index == 1 ? '2023-24' : event?.element?.index == 2 ? '2024-25' : event?.element?.index == 3 ? '2025-26' : '2022-23 Onwards';
    this.selectedYearForData = event?.element?.index == 0 ? '2022-23' : event?.element?.index == 1 ? '2023-24' : event?.element?.index == 2 ? '2024-25' : event?.element?.index == 3 ? '2025-26' : '';
    this.yearHeaderColor = event?.element?.index == 0 ? '#990000' : event?.element?.index == 1 ? '#ff1a1a' : event?.element?.index == 2 ? '#ff6666' : event?.element?.index == 3 ? '#550000'  : 'black';
    // this.yearHeadertext = year;
    // this.selectedYearForData = year;

    // this.loadMIData();

    // this.showPONDDistrciData = false;
    // this.loadMIDistrictWiseData('');
    // this.pondDistrictWiseDashboardData = false;
    // this.pondDistrictWiseDashboarSchemedData = [];
    // this.loadMIDistrictWiseDashboardData('');
    // this.loadMIDistrictWiseDashboardSchemeData('');

    // this.showMIDistrciData = true;
    // this.districtWiseHeader = `All districts details`

    // this.onMIChartClick({ element: { index: 100 } });

    this.onPieChartClick({ element: { index: 0 } });
    this.onMIChartClick({ element: { index: 100 } });
  }

  onPiePondYearWiseChartClick(event) {
    this.filterTypeName = 'Pond';

    this.yearHeadertext = event?.element?.index == 0 ? '2022-23' : event?.element?.index == 1 ? '2023-24' : event?.element?.index == 2 ? '2024-25' : event?.element?.index == 3 ? '2025-26' : '2022-23 Onwards';
    this.selectedYearForData = event?.element?.index == 0 ? '2022-23' : event?.element?.index == 1 ? '2023-24' : event?.element?.index == 2 ? '2024-25' : event?.element?.index == 3 ? '2025-26' : '';
    this.yearHeaderColor = event?.element?.index == 0 ? '#990000' : event?.element?.index == 1 ? '#ff1a1a' : event?.element?.index == 2 ? '#550000' : event?.element?.index == 3 ? '2025-26' : 'black';
    // this.yearHeadertext = year;
    // this.selectedYearForData = year;

    // this.loadPondData();

    // this.showMIDistrciData = false;
    // this.loadPONDDistrictWiseData('');
    // this.miDistrictWiseDashboardData = false;
    // this.miDistrictWiseDashboarSchemedData = [];
    // this.loadPONDDistrictWiseDashboardData('');
    // this.loadPondDistrictWiseDashboardSchemeData('');

    // this.showPONDDistrciData = true;
    // this.districtWiseHeader = `All districts details`

    // this.onPondChartClick({ element: { index: 100 } });

    this.onPieChartClick({ element: { index: 1 } });
    this.onPondChartClick({ element: { index: 100 } });
  }

  loadMIDistrictWiseData(districtData) {
    this.loader.start();
    let sub = this.reportsService
      .getDistrictWiseAllCountDashboard(districtData, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miDistrictWiseData = data;
            this.loadMIDistrictWiseDataForChart();

          } else {
            this.miDistrictWiseData = [];
            this.loadMIDistrictWiseDataForChart();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miDistrictWiseData = [];
          this.loadMIDistrictWiseDataForChart();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIDistrictWiseDashboardSchemeData(districtCode) {
    // this.loader.start();
    let sub = this.reportsService
      .getMISchemeWiseAppCount(districtCode, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          if (data?.length > 0) {
            this.miDistrictWiseDashboarSchemedData = data;
            this.loadMISchemeBarDataDistrictWise();
          } else {
            this.miDistrictWiseDashboarSchemedData = [];
            this.loadMISchemeBarDataDistrictWise();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.miDistrictWiseDashboarSchemedData = [];
          this.loadMISchemeBarDataDistrictWise();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIDistrictWiseDashboardData(districtCode) {
    this.loader.start();
    let sub = this.reportsService
      .getDataForDashboardGraphs(districtCode, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miDistrictWiseDashboardData = data;
            this.loadPieDataDistrictWise();
          } else {
            this.miDistrictWiseDashboardData = [];
            this.loadPieDataDistrictWise();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miDistrictWiseDashboardData = [];
          this.loadPieDataDistrictWise();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIDistrictWiseDataForChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const districts = this.miDistrictWiseData.map(item => item.District);
    const totalApp = this.miDistrictWiseData.map(item => item.totalApp);
    const totalArea = this.miDistrictWiseData.map(item => (item.TotalArea).toFixed(2));


    const labels = totalApp.map((count, index) => `Count: ${count}. Area: ${totalArea[index]}`);

    this.miDistrictWiseDataForChart = {
      labels: districts,
      datasets: [
        {
          data: totalApp,
          backgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          hoverBackgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          label: labels
        },

      ],
    };
    

    this.optionsMIDW = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold',
            size: '10px'
          },
        },
        legend: {
          display: false // Hide the legend
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              const index = tooltipItem.dataIndex;
              return `Count: ${totalApp[index]}. Area: ${totalArea[index]}`;
            }
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            // min: 0,
            // stepSize: 200,
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : (value / 1000) + 'K';
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
        // y: {
        //   type: 'logarithmic', // Use logarithmic scale
        //   ticks: {
        //     min: 0,
        //     font: {
        //       weight: 'bold',
        //       color: 'black'
        //     },
        //   },
        //   grid: {
        //     display: false,
        //     // color: this.surfaceBorder,
        //     // drawBorder: false,
        //   },
        // },

      }
    };
  }

  loadPondDistrictWiseDashboardSchemeData(districtCode) {
    // this.loader.start();
    let sub = this.reportsService
      .getPondSchemeWiseAppCount(districtCode, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          if (data?.length > 0) {
            this.pondDistrictWiseDashboarSchemedData = data;
            this.loadPondSchemeBarDataDistrictWise();
          } else {
            this.pondDistrictWiseDashboarSchemedData = [];
            this.loadPondSchemeBarDataDistrictWise();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.pondDistrictWiseDashboarSchemedData = [];
          this.loadPondSchemeBarDataDistrictWise();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadPONDDistrictWiseData(districtCode) {
    this.loader.start();
    let sub = this.reportsService
      .getDistrictWiseAllCountDashboardPond(districtCode, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.pondDistrictWiseData = data;
            this.loadPondDistrictWiseDataForChart();

          } else {
            this.pondDistrictWiseData = [];
            this.loadPondDistrictWiseDataForChart();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.pondDistrictWiseData = [];
          this.loadPondDistrictWiseDataForChart();
        },
      });
  }
  loadPONDDistrictWiseDashboardData(districtCode) {
    this.loader.start();
    let sub = this.reportsService
      .getDataForDashboardGraphsPond(districtCode, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.pondDistrictWiseDashboardData = data;
            this.loadPondPieDataDistrictWise();
          } else {
            this.pondDistrictWiseDashboardData = [];
            this.loadPondPieDataDistrictWise();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.pondDistrictWiseDashboardData = [];
          this.loadPondPieDataDistrictWise();
        },
      });
  }

  loadPondDistrictWiseDataForChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const districts = this.pondDistrictWiseData.map(item => item.District);
    const totalApp = this.pondDistrictWiseData.map(item => item.totalApp);
    const totalArea = this.miDistrictWiseData.map(item => (item.TotalArea).toFixed(2));

    const labels = totalApp.map((count, index) => `Count: ${count}. Area: ${totalArea[index]}`);

    this.pondDistrictWiseDataForChart = {
      labels: districts,
      datasets: [
        {
          data: totalApp,
          backgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          hoverBackgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          label: labels
        },
      ],
    };

    this.optionsPondDW = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold',
            size: '10px'
          },
        },
        legend: {
          display: false // Hide the legend
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              const index = tooltipItem.dataIndex;
              return `Count: ${totalApp[index]}. Area: ${totalArea[index]}`;
            }
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            // min: 0,
            // stepSize: 200,
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : (value / 1000) + 'K';
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
        // y: {
        //   type: 'logarithmic', // Use logarithmic scale
        //   ticks: {
        //     min: 0,
        //     font: {
        //       weight: 'bold',
        //       color: 'black'
        //     },
        //   },
        //   grid: {
        //     display: false,
        //     // color: this.surfaceBorder,
        //     // drawBorder: false,
        //   },
        // },

      }
    };
  }

  onDistrictChartClick(event) {
    let districtCode: any = '';
    let selectedDistrict: any = 'All District';
    let indexVal = event?.element?.index;
    if (indexVal == 0) {
      districtCode = '01'; //Ambala
      selectedDistrict = 'Ambala';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 1) {
      districtCode = '02'; // Bhiwani
      selectedDistrict = 'Bhiwani';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 3) {
      districtCode = '03'; // Faridabad
      selectedDistrict = 'Faridabad';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 4) {
      districtCode = '04'; // Fatehabad
      selectedDistrict = 'Fatehabad';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 5) {
      districtCode = '05'; // Gurugram
      selectedDistrict = 'Gurugram';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 6) {
      districtCode = '06'; // Hissar
      selectedDistrict = 'Hissar';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 7) {
      districtCode = '07'; // Jhajjar
      selectedDistrict = 'Jhajjar';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 8) {
      districtCode = '08'; // Jind
      selectedDistrict = 'Jind';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 9) {
      districtCode = '09'; // Kaithal
      selectedDistrict = 'Kaithal';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 10) {
      districtCode = '10'; // Karnal
      selectedDistrict = 'Karnal';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 11) {
      districtCode = '11'; // Kurukshetra
      selectedDistrict = 'Kurukshetra';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 12) {
      districtCode = '12'; // Mahindergarh
      selectedDistrict = 'Mahindergarh';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 15) {
      districtCode = '13'; // Panchkula
      selectedDistrict = 'Panchkula';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 16) {
      districtCode = '14'; // Panipat
      selectedDistrict = 'Panipat';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 17) {
      districtCode = '15'; // Rewari
      selectedDistrict = 'Rewari';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 18) {
      districtCode = '16'; // Rohtak
      selectedDistrict = 'Rohtak';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 19) {
      districtCode = '17'; // Sirsa
      selectedDistrict = 'Sirsa';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 20) {
      districtCode = '18'; // Sonipat
      selectedDistrict = 'Sonipat';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 21) {
      districtCode = '19'; // Yamunanagar
      selectedDistrict = 'Yamunanagar';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 13) {
      districtCode = '20'; // Nuh
      selectedDistrict = 'Nuh';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 14) {
      districtCode = '21'; // Palwal
      selectedDistrict = 'Palwal';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 2) {
      districtCode = '22'; // Charkhi Dadri
      selectedDistrict = 'Charkhi Dadri';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    } else {
      selectedDistrict = 'all district';
      this.loadMIDistrictWiseDashboardData(districtCode);
      this.loadMIDistrictWiseDashboardSchemeData(districtCode);
    }

    setTimeout(() => this.miDistrictWiseDataCard.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)

    this.districtWiseHeader = `District: ${selectedDistrict}`
  }

  onPondDistrictChartClick(event) {
    let districtCode: any = '';
    let selectedDistrict: any = 'All District';
    let indexVal = event?.element?.index;
    if (indexVal == 0) {
      districtCode = '01'; //Ambala
      selectedDistrict = 'Ambala';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 1) {
      districtCode = '02'; // Bhiwani
      selectedDistrict = 'Bhiwani';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 3) {
      districtCode = '04'; // Fatehabad
      selectedDistrict = 'Fatehabad';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 4) {
      districtCode = '06'; // Hissar
      selectedDistrict = 'Hissar';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 5) {
      districtCode = '07'; // Jhajjar
      selectedDistrict = 'Jhajjar';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 6) {
      districtCode = '08'; // Jind
      selectedDistrict = 'Jind';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 7) {
      districtCode = '09'; // Kaithal
      selectedDistrict = 'Kaithal';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 8) {
      districtCode = '11'; // Kurukshetra
      selectedDistrict = 'Kurukshetra';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 9) {
      districtCode = '12'; // Mahindergarh
      selectedDistrict = 'Mahindergarh';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 11) {
      districtCode = '13'; // Panchkula
      selectedDistrict = 'Panchkula';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 12) {
      districtCode = '16'; // Rohtak
      selectedDistrict = 'Rohtak';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 13) {
      districtCode = '17'; // Sirsa
      selectedDistrict = 'Sirsa';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 14) {
      districtCode = '19'; // Yamunanagar
      selectedDistrict = 'Yamunanagar';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    } else if (indexVal == 10) {
      districtCode = '21'; // Palwal
      selectedDistrict = 'Palwal';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    }
    else if (indexVal == 2) {
      districtCode = '22'; // Charkhi Dadri
      selectedDistrict = 'Charkhi Dadri';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    }
    else {
      selectedDistrict = 'all district';
      this.loadPONDDistrictWiseDashboardData(districtCode);
      this.loadPondDistrictWiseDashboardSchemeData(districtCode);
    }

    setTimeout(() => this.pondDistrictWiseDataCard.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)

    this.districtWiseHeader = `District: ${selectedDistrict}`
  }

  loadMISchemeBarDataDistrictWise() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    let scheme = [];
    let totalApp = []
    if (this.miDistrictWiseDashboarSchemedData.length > 0) {
      scheme = this.miDistrictWiseDashboarSchemedData.map(item => item.Scheme);
      totalApp = this.miDistrictWiseDashboarSchemedData.map(item => item.TotalApps);
    } else {
      scheme = [];
      totalApp = []
    }

    this.miDistrictWiseSchemeDataForGraph = {
      labels: scheme,
      datasets: [
        {
          data: totalApp,
          backgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          hoverBackgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          label: ''
        },
      ],
    };

    this.optionsMIScheme = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : value;
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
      }
    };
  }

  loadPondSchemeBarDataDistrictWise() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    let scheme = [];
    let totalApp = []
    if (this.pondDistrictWiseDashboarSchemedData.length > 0) {
      scheme = this.pondDistrictWiseDashboarSchemedData.map(item => item.Scheme);
      totalApp = this.pondDistrictWiseDashboarSchemedData.map(item => item.TotalApps);
    } else {
      scheme = [];
      totalApp = []
    }

    this.pondDistrictWiseSchemeDataForGraph = {
      labels: scheme,
      datasets: [
        {
          data: totalApp,
          backgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          hoverBackgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          label: ''
        },
      ],
    };

    this.optionsMIScheme = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : value;
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
      }
    };
  }

  loadPieDataDistrictWise() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    // user wise
    const atalUserData = this.miDistrictWiseDashboardData[0][0];
    const normalUserData = this.miDistrictWiseDashboardData[1][0];

    // caste wise
    const casteWiseData = this.miDistrictWiseDashboardData[2];

    // component wise
    const componentWiseData = this.miDistrictWiseDashboardData[3];

    // line graph for yearWise area
    const yearWiseArea = this.miDistrictWiseDashboardData[4];

    const completedAppReport = this.miDistrictWiseDashboardData[5][0];

    this.totalSubsidyDisbursed = completedAppReport?.paymentDoneCAO / 10000000;
    this.totalAppCompleted = completedAppReport?.Payment_Done_Application_By_CAO;
    this.totalMIAreaCompleted = completedAppReport?.Payment_done_MI_Area;

    if (this.showMIDistrciData) {
      this.animateCounter('totalSubsidyDisbursed', this.totalSubsidyDisbursed);
      this.animateCounter('totalAppCompleted', this.totalAppCompleted);
      this.animateCounter('totalMIAreaCompleted', this.totalMIAreaCompleted);
    }

    this.subsidyDataForChart = {
      labels: [`Application Completed (${atalUserData?.Payment_Done_Application_By_CAO + normalUserData?.Payment_Done_Application_By_CAO})`, `Application Pending (${(atalUserData?.totalApp + normalUserData?.totalApp) - (atalUserData?.Payment_Done_Application_By_CAO + normalUserData?.Payment_Done_Application_By_CAO)})`],
      datasets: [
        {
          data: [atalUserData?.Payment_Done_Application_By_CAO + normalUserData?.Payment_Done_Application_By_CAO,
          (atalUserData?.totalApp + normalUserData?.totalApp) - (atalUserData?.Payment_Done_Application_By_CAO + normalUserData?.Payment_Done_Application_By_CAO)
          ],
          backgroundColor: [
            '#09b328',
            '#e8c123'
          ],
          hoverBackgroundColor: [
            '#09b328',
            '#e8c123'
          ],
          borderWidth: 2
        },
      ],
    };

    this.subsidyAreaDataForChart = {
      labels: [`Disbursed Area (${atalUserData?.Payment_done_MI_Area + normalUserData?.Payment_done_MI_Area})`, `Pending Area (${(atalUserData?.UnProcessedAppsArea) + (normalUserData?.UnProcessedAppsArea)})`],
      datasets: [
        {
          data: [atalUserData?.Payment_done_MI_Area + normalUserData?.Payment_done_MI_Area,
          (atalUserData?.UnProcessedAppsArea) + (normalUserData?.UnProcessedAppsArea)],
          backgroundColor: [
            '#b300b3',
            '#0000e6'
          ],
          hoverBackgroundColor: [
            '#b300b3',
            '#0000e6'
          ],
          borderWidth: 2
        },
      ],
    };

    this.subsidyAmountDataForChart = {
      labels: [`Disbursed Amount (${atalUserData?.Payment_done_MI_Area + normalUserData?.Payment_done_MI_Area})`, `Pending Amount (${atalUserData?.pending + normalUserData?.pending})`],
      datasets: [
        {
          data: [atalUserData?.Payment_done_MI_Area + normalUserData?.Payment_done_MI_Area, atalUserData?.pending + normalUserData?.pending],
          backgroundColor: [
            '#8c1aff',
            '#e67300'
          ],
          hoverBackgroundColor: [
            '#8c1aff',
            '#e67300'
          ],
          borderWidth: 2
        },
      ],
    };

    this.casteDataForChart = {
      labels: [`Gen (${casteWiseData[0]?.totalApp})`, `BC (${casteWiseData[1]?.totalApp})`, `SC/ST(${casteWiseData[2]?.totalApp})`],
      datasets: [
        {
          data: [casteWiseData[0]?.totalApp, casteWiseData[1]?.totalApp, casteWiseData[2]?.totalApp],
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#37b4c4',
            '#0f48f5',
            '#b90cf2'
          ],
          hoverBackgroundColor: [
            '#37b4c4',
            '#0f48f5',
            '#b90cf2'
          ],
          borderWidth: 2
        },
      ],
    };

    this.appTypeDataForChart = {
      labels: [`ABY (${atalUserData?.totalApp})`, `Normal (${normalUserData?.totalApp})`],
      datasets: [
        {
          data: [atalUserData?.totalApp, normalUserData?.totalApp],
          backgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          borderWidth: 2
        },
      ],
    };

    this.componentDataForChart = {
      labels: [`Portable (${componentWiseData[1]?.TotalApp})`, `Mini (${componentWiseData[0]?.TotalApp})`, `Drip (${componentWiseData[2]?.TotalApp})`],
      datasets: [
        {
          data: [componentWiseData[1]?.TotalApp, componentWiseData[0]?.TotalApp, componentWiseData[2]?.TotalApp],
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#990073',
            '#6600ff',
            '#00b33c'
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          borderWidth: 2
        },
      ],
    };

    let yearName = yearWiseArea.map(item => item.FinYear);
    let yearVal = yearWiseArea.map(item => item.TotalArea);

    this.yearWiseDataForChart = {
      labels: yearName,
      datasets: [
        {
          data: yearVal,
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#990073',
            '#6600ff',
            '#00b33c'
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4
        },
      ],
    };

    this.optionsLine = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          display: false // Hide the legend
        },
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: true
          }
        },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : value;
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
      },
    };

    this.options2 = {
      responsive: true,
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: 'white',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
      animation: {
        animateScale: true,
        animateRotate: true
      },
      cutout: '0%',
      elements: {
        arc: {
          borderWidth: 0,
          borderAlign: 'center',
          offset: 30
        }
      },
    };
  }

  loadPondPieDataDistrictWise() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    // user wise
    const atalUserData = this.pondDistrictWiseDashboardData[0][0];
    const normalUserData = this.pondDistrictWiseDashboardData[1][0];

    // caste wise
    const casteWiseData = this.pondDistrictWiseDashboardData[2];

    // component wise
    // const componentWiseData = this.pondDistrictWiseDashboardData[3];

    // line graph for yearWise area
    const yearWiseArea = this.pondDistrictWiseDashboardData[4];

    const completedAppReport = this.pondDistrictWiseDashboardData[5][0];

    this.totalSubsidyDisbursedPond1STage = completedAppReport?.PaymentAmtStage1CAO / 10000000;
    this.totalAppCompletedPond1STage = completedAppReport?.PaymentDoneCAOStage1;
    this.totalAreaCompletedPond1STage = completedAppReport?.PaymentDoneCAOStage1Area;

    this.totalSubsidyDisbursedPond2STage = completedAppReport?.PaymentAmtStage2CAO / 10000000;
    this.totalAppCompletedPond2STage = completedAppReport?.PaymentDoneCAOStage2;
    this.totalAreaCompletedPond2STage = completedAppReport?.PaymentDoneCAOStage2Area;

    this.totalSubsidyDisbursedPond3STage = completedAppReport?.PaymentAmtStage3CAO / 10000000;
    this.totalAppCompletedPond3STage = completedAppReport?.PaymentDoneCAOStage3;
    this.totalAreaCompletedPond3STage = completedAppReport?.PaymentDoneCAOStage3Area;



    if (this.showPONDDistrciData) {
      this.animateCounter('totalSubsidyDisbursedPond1STage', this.totalSubsidyDisbursedPond1STage);
      this.animateCounter('totalAppCompletedPond1STage', this.totalAppCompletedPond1STage);
      this.animateCounter('totalAreaCompletedPond1STage', this.totalAreaCompletedPond1STage);

      this.animateCounter('totalSubsidyDisbursedPond2STage', this.totalSubsidyDisbursedPond2STage);
      this.animateCounter('totalAppCompletedPond2STage', this.totalAppCompletedPond2STage);
      this.animateCounter('totalAreaCompletedPond2STage', this.totalAreaCompletedPond2STage);

      this.animateCounter('totalSubsidyDisbursedPond3STage', this.totalSubsidyDisbursedPond3STage);
      this.animateCounter('totalAppCompletedPond3STage', this.totalAppCompletedPond3STage);
      this.animateCounter('totalAreaCompletedPond3STage', this.totalAreaCompletedPond3STage);
    }

    this.subsidyDataForChart = {
      labels: [`Completed App Stage 1 (${completedAppReport?.PaymentDoneCAOStage1})`, `Completed App Stage 2 (${completedAppReport?.PaymentDoneCAOStage2})`, `Completed App Stage 3 (${completedAppReport?.PaymentDoneCAOStage3})`],
      datasets: [
        {
          data: [completedAppReport?.PaymentDoneCAOStage1, completedAppReport?.PaymentDoneCAOStage2, completedAppReport?.PaymentDoneCAOStage3
          ],
          backgroundColor: [
            '#09b328',
            '#e8c123',
            '#b300b3'
          ],
          hoverBackgroundColor: [
            '#09b328',
            '#e8c123',
            '#b300b3'
          ],
          borderWidth: 2
        },
      ],
    };

    this.subsidyAreaDataForChart = {
      labels: [`Disbursed Amt Stage 1 (${completedAppReport?.PaymentAmtStage1CAO})`, `Disbursed Amt Stage 2 (${completedAppReport?.PaymentAmtStage2CAO})`, `Disbursed Amt Stage 3 (${completedAppReport?.PaymentAmtStage3CAO})`],
      datasets: [
        {
          data: [completedAppReport?.PaymentAmtStage1CAO, completedAppReport?.PaymentAmtStage2CAO, completedAppReport?.PaymentAmtStage3CAO,
          ],
          backgroundColor: [
            '#b300b3',
            '#0000e6',
            '#09b328'
          ],
          hoverBackgroundColor: [
            '#b300b3',
            '#0000e6',
            '#09b328'
          ],
          borderWidth: 2
        },
      ],
    };

    this.Paymentstage = {
      labels: [`Completed Area Stage 1 (${completedAppReport?.PaymentDoneCAOStage1Area})`, `Completed Area Stage 2 (${completedAppReport?.PaymentDoneCAOStage2Area})`, `Completed Area Stage 3 (${completedAppReport?.PaymentDoneCAOStage3Area})`],
      datasets: [
        {
          data: [completedAppReport?.PaymentDoneCAOStage1Area, completedAppReport?.PaymentDoneCAOStage2Area, completedAppReport?.PaymentDoneCAOStage3Area],
          backgroundColor: [
            '#8c1aff',
            '#e67300',
            '#09b328'
          ],
          hoverBackgroundColor: [
            '#8c1aff',
            '#e67300',
            '#09b328'
          ],
          borderWidth: 2
        },
      ],
    };

    this.casteDataForChart = {
      labels: [`Gen (${casteWiseData[0]?.totalApp})`, `BC (${casteWiseData[1]?.totalApp})`, `SC/ST (${casteWiseData[2]?.totalApp})`],
      datasets: [
        {
          data: [casteWiseData[0]?.totalApp, casteWiseData[1]?.totalApp, casteWiseData[2]?.totalApp],
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#37b4c4',
            '#0f48f5',
            '#b90cf2'
          ],
          hoverBackgroundColor: [
            '#37b4c4',
            '#0f48f5',
            '#b90cf2'
          ],
          borderWidth: 2
        },
      ],
    };

    this.appTypeDataForChart = {
      labels: [`ABY (${atalUserData?.totalApp})`, `Normal (${normalUserData?.totalApp})`],
      datasets: [
        {
          data: [atalUserData?.totalApp, normalUserData?.totalApp],
          backgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          borderWidth: 2
        },
      ],
    };

    // this.componentDataForChart = {
    //   labels: [`Portable`,  `Mini`, `Drip` ],
    //   datasets: [
    //     {
    //       data: [componentWiseData[0]?.TotalApp, componentWiseData[1]?.TotalApp, componentWiseData[2]?.TotalApp],
    //       backgroundColor: [
    //         // documentStyle.getPropertyValue('--cyan-700'),
    //         // documentStyle.getPropertyValue('--pink-600'),
    //         '#990073',
    //         '#6600ff',
    //         '#00b33c'
    //       ],
    //       hoverBackgroundColor: [
    //         documentStyle.getPropertyValue('--cyan-700'),
    //         documentStyle.getPropertyValue('--pink-600'),
    //       ],
    //       borderWidth: 2
    //     },
    //   ],
    // };

    let yearName = yearWiseArea.map(item => item.FinYear);
    let yearVal = yearWiseArea.map(item => item.TotalArea);

    this.yearWiseDataForChart = {
      labels: yearName,
      datasets: [
        {
          data: yearVal,
          backgroundColor: [
            '#990073',
            '#6600ff',
            '#00b33c'
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4
        },
      ],
    };

    this.optionsLine = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          display: false // Hide the legend
        },
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: true
          }
        },
        y: {
          type: 'linear', // Use linear scale
          ticks: {
            callback: function (value, index, values) {
              // Custom tick labeling logic
              return value > 1000 ? (value / 1000) + 'K' : value;
            },
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          grid: {
            display: false,
          },
        },
      },
    };

    this.options2 = {
      responsive: true,
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: 'white',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
      animation: {
        animateScale: true,
        animateRotate: true
      },
      cutout: '0%',
      elements: {
        arc: {
          borderWidth: 0,
          borderAlign: 'center',
          offset: 15
        }
      },
    };
  }

  viewMIConsolidatedReport() {
    if (this.userId == 'admin') {
      // this.router.navigate(['admin', 'report', 'mi-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['admin', 'report', 'mi-total-app-report']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'cao') {
      // this.router.navigate(['cao', 'report', 'mi-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['cao', 'report', 'mi-total-app-report']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'webadmin') {
      // this.router.navigate(['cao', 'report', 'mi-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['webadmin', 'report', 'mi-total-app-report']));
      window.open(url, '_blank');
    }
    else {
      // this.router.navigate(['department', 'report', 'mi-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['department', 'report', 'mi-total-app-report']));
      window.open(url, '_blank');
    }
  }

  viewMIConsolidatedDetails() {
    if (this.userId == 'admin') {
      // this.router.navigate(['admin', 'report', 'mi-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['admin', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'cao') {
      // this.router.navigate(['cao', 'report', 'mi-consolidated-details']);

      const url = this.router.serializeUrl(
        this.router.createUrlTree(['cao', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'webadmin') {
      // this.router.navigate(['cao', 'report', 'mi-consolidated-details']);

      const url = this.router.serializeUrl(
        this.router.createUrlTree(['webadmin', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
    else {
      // this.router.navigate(['department', 'report', 'mi-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['department', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
  }


  viewPondConsolidatedReport() {
    if (this.userId == 'admin') {
      // this.router.navigate(['admin', 'report', 'pond-total-app-report']);
      // 
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['admin', 'report', 'pond-total-app-report']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'cao') {
      // this.router.navigate(['cao', 'report', 'pond-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['cao', 'report', 'pond-total-app-report']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'webadmin') {
      // this.router.navigate(['cao', 'report', 'pond-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['webadmin', 'report', 'pond-total-app-report']));
      window.open(url, '_blank');
    }
    else {
      // this.router.navigate(['department', 'report', 'pond-total-app-report']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['department', 'report', 'pond-total-app-report']));
      window.open(url, '_blank');
    }
  }

  viewPondConsolidatedDetails() {
    if (this.userId == 'admin') {
      // this.router.navigate(['admin', 'report', 'pond-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['admin', 'report', 'pond-consolidated-details']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'cao') {
      // this.router.navigate(['cao', 'report', 'pond-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['cao', 'report', 'pond-consolidated-details']));
      window.open(url, '_blank');
    }
    else if (this.userId == 'webadmin') {
      // this.router.navigate(['cao', 'report', 'pond-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['webadmin', 'report', 'pond-consolidated-details']));
      window.open(url, '_blank');
    }
    else {
      // this.router.navigate(['department', 'report', 'pond-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['department', 'report', 'pond-consolidated-details']));
      window.open(url, '_blank');
    }
  }
}
